import * as tslib_1 from "tslib";
import { InjectionToken, } from '@angular/core';
import { ReplaySubject, } from 'rxjs';
import { switchMap, take, } from 'rxjs/operators';
export var COLOR_PROVIDER = new InjectionToken('Chart Color Provider');
var ColorProvider = /** @class */ (function () {
    function ColorProvider(zone) {
        this._changes = new ReplaySubject(1);
        this.changes$ = this._changes.pipe(switchMap(function () { return zone.onStable.pipe(take(1)); }));
        this._changes.next();
    }
    ColorProvider.prototype.destroy = function () {
        this._changes.complete();
    };
    return ColorProvider;
}());
export { ColorProvider };
var DefaultColorProvider = /** @class */ (function (_super) {
    tslib_1.__extends(DefaultColorProvider, _super);
    function DefaultColorProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textColor = '#121212';
        _this.tooltipTextColor = '#121212';
        _this.tooltipBackgroundColor = 'white';
        _this.legendTextColor = '#121212';
        _this.legendInactiveColor = '#ccc';
        _this.axisTextColor = '#121212';
        _this.axisLineColor = '#121212';
        _this.gridLineColor = '#ddd';
        _this.axisHoverColor = 'rgba(0, 0, 0, .1)';
        return _this;
    }
    return DefaultColorProvider;
}(ColorProvider));
export { DefaultColorProvider };
